var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFlexibleLimit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12.0970556px",
    viewBox: "0 0 14 12.0970556",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 33") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u3010\\u805A\\u878D\\u6613\\u3011\\u5339\\u914D\\u4EA7\\u54C1\\uFF082\\u4E2A\\uFF09_\\u7D2B\\u8272",
    transform: "translate(-281.000000, -293.902944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-34",
    transform: "translate(15.000000, 185.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-32",
    transform: "translate(13.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-33",
    transform: "translate(253.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#999999",
    strokeWidth: 1.083,
    x: 0.5415,
    y: 1.87483333,
    width: 12.917,
    height: 9.58366667,
    rx: 1.805
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21114465,6.58931809 C9.44099798,6.58570591 9.625,6.37307106 9.625,6.15948478 C9.625,6.05458642 9.5828318,5.93554574 9.50621971,5.86317313 C9.42953942,5.78715608 9.3222518,5.74738985 9.21114465,5.74374542 L7.41770897,5.74374542 L7.41770897,5.51691986 C7.41770897,5.50053604 7.42125567,5.49695611 7.43684068,5.47960475 L9.22175065,3.85850989 C9.3788114,3.70294426 9.3788114,3.45678385 9.22175065,3.30120209 C9.14507035,3.2252173 9.00035483,3.11111111 8.88924769,3.11111111 C8.77779681,3.11122115 8.67122319,3.15435207 8.59418968,3.23052269 L6.9999659,4.72809389 L5.40582737,3.21283268 C5.24107642,3.0608631 4.94301736,3.14921639 4.78205182,3.30120209 C4.62499107,3.45678385 4.62499107,3.70294426 4.78205182,3.85850989 L6.56696179,5.47960475 C6.57115644,5.48408772 6.58611055,5.5011972 6.58611055,5.51529115 L6.58611055,5.7474221 L4.78885535,5.7474221 C4.67768,5.7474221 4.57426305,5.79083277 4.49379734,5.86683368 C4.41711704,5.9428346 4.375,6.05816635 4.375,6.16314534 C4.375,6.38026317 4.55889971,6.5930109 4.78883829,6.5930109 L6.56361971,6.5930109 L6.56361971,6.97827249 L4.78885535,6.97827249 C4.55891676,6.98188467 4.375,7.19455178 4.375,7.41170186 C4.375,7.62880357 4.55889971,7.82379679 4.78885535,7.82379679 L6.56361971,7.82379679 L6.56361971,8.93889616 C6.56361971,9.15599786 6.76622485,9.33333333 6.99619753,9.33333333 C7.22611906,9.32972115 7.4287583,9.15240181 7.4287583,8.93889616 L7.4287583,7.82379679 L9.20350561,7.82379679 C9.43344419,7.82023299 9.61734391,7.62520751 9.61734391,7.41170186 C9.61734391,7.19456791 9.43346125,6.98188467 9.20350561,6.97827249 L7.4287583,6.97827249 L7.4287583,6.5930109 L9.21116171,6.5930109 L9.21116171,6.58930197 L9.21114465,6.58931809 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#999999",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.56176758,
    y1: 0.444444444,
    x2: 11.2587891,
    y2: 0.444444444,
    id: "\\u8DEF\\u5F84-22",
    stroke: "#999999",
    strokeWidth: 1.083,
    strokeLinecap: "round"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlexibleLimit);
export default __webpack_public_path__ + "static/media/icon-flexible-limit.2f14ecfd74c861ce6d124953499d6eee.svg";
export { ForwardRef as ReactComponent };